import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import {
  SidebarTitle,
  SidebarSectionLabel,
  SidebarClearAllFooter,
} from 'components/layout/SidebarLayout';
import CityFilter from 'components/widgets/CompanySearch/CompanySidebarFilter/CityFilter';
import CompanyTypeFilter from 'components/widgets/CompanySearch/CompanySidebarFilter/CompanyTypeFilter';
import LocationFilter from 'components/widgets/CompanySearch/CompanySidebarFilter/LocationFilter';
import StateFilter from 'components/widgets/CompanySearch/CompanySidebarFilter/StateFilter';
import { FilterContextProvider } from 'components/widgets/FilterToolbar/FilterContext';
import {
  useCompanyTypeFilterState,
  useResetCompanyLocationFilters,
} from 'state/filterCompanies';

const containerStyle = {
  height: '100%',
  width: '100%',
};

const scrollStyle = {
  overflowY: 'auto',
  width: '100%',
  flex: 1,
};

const CompanySidebarFilter = () => {
  const { resetLocationFilters } = useResetCompanyLocationFilters();
  const { resetCompanyTypeFilter } = useCompanyTypeFilterState();

  const handleClearAll = () => {
    resetLocationFilters();
    resetCompanyTypeFilter();
  };

  return (
    <FlexColumn sx={containerStyle}>
      <SidebarTitle>Company Directory</SidebarTitle>
      <FilterContextProvider>
        <FlexColumn sx={scrollStyle}>
          <SidebarSectionLabel label="Location" isFirst />
          <StateFilter />
          <LocationFilter />
          <CityFilter />
          <CompanyTypeFilter />
        </FlexColumn>
      </FilterContextProvider>
      <SidebarClearAllFooter onClick={handleClearAll} />
    </FlexColumn>
  );
};

export default CompanySidebarFilter;
